import { gql } from '@apollo/client';

export const UPDATE_MY_CB_SUBSCRIPTION = gql`
  mutation UpdateMyCbSubscription($input: UpdateMyCbSubscriptionInput!) {
    updateMyCbSubscription(input: $input) {
      items {
        id
      }
    }
  }
`;

export const CANCEL_CB_SUBSCRIPTION = gql`
  mutation CancelCbSubscription($input: CancelCbSubscriptionInput!) {
    cancelCbSubscription(input: $input) {
      id
    }
  }
`;

export const CANCEL_CB_SUBSCRIPTION_DOWNGRADE = gql`
  mutation CancelCbSubscriptionDowngrade(
    $input: CancelCbSubscriptionDowngradeInput!
  ) {
    cancelCbSubscriptionDowngrade(input: $input) {
      id
    }
  }
`;

export const VOID_CANCEL_CB_SUBSCRIPTION = gql`
  mutation VoidCancelCbSubscription($input: VoidCancelCbSubscriptionInput!) {
    voidCancelCbSubscription(input: $input) {
      id
    }
  }
`;

export const SET_CB_ENTITLEMENT = gql`
  mutation SetCbEntitlement($input: SetCbEntitlementInput!) {
    setCbEntitlement(input: $input) {
      id
      ... on CbTeamEntitlement {
        seats
      }
    }
  }
`;
